import React, { FC, useEffect, useState } from "react";
import { Divider, List, ListItem, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { Marker, Popup, useMap, useMapEvents } from "react-leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import { divIcon } from "leaflet";

import { dispatcherDuck } from "lib/ducks";
import { Kns, Vns } from "lib/types";
import { someIncludes } from "lib/helpers";
import { DeviceEmergencyCodeEnum, FacilityTypeEnum } from "lib/enums";

import { ErrorIcon, GreenPointIcon, RepairIcon } from "components/ui";
import { MarkerIconContainer } from "./styled";
import MarkerKnsVns from "./Marker";

export const MapComponent: FC = observer(() => {
  const map = useMap();
  useMapEvents({
    moveend() {
      dispatcherDuck.isTracking && handleMove();
    },
  });
  const [locations, setLocations] = useState<any>({} as any);
  const [activeDeviceCode, setActiveDeviceCode] = useState<number | null>(null);

  const handleMove = () => {
    let kns: Kns[] = [];
    let vns: Vns[] = [];
    Object.values(locations).forEach((location: any) => {
      const {
        location: { lat, lon },
      } = location;
      if (map.getBounds().contains([lat, lon])) {
        kns.push(
          ...location.popups.filter(
            (element: Kns | Vns) => element.type === FacilityTypeEnum.KNS,
          ),
        );
        vns.push(
          ...location.popups.filter(
            (element: Kns | Vns) => element.type === FacilityTypeEnum.VNS,
          ),
        );
      }
    });
    dispatcherDuck.trackingKns = [...kns];
    dispatcherDuck.trackingVns = [...vns];
  };

  useEffect(() => {
    // закоментил чтобы не брар текущую позицию пользователя
    // navigator.geolocation.getCurrentPosition((position) => {
    //   let lat = position.coords.latitude;
    //   let lon = position.coords.longitude;
    //   map.setView([lat, lon]);
    // });
  }, []);

  useEffect(() => {
    const { active } = dispatcherDuck;
    if (active && active.deviceCode !== activeDeviceCode) {
      if (active.location?.lat && active.location?.lon) {
        map.flyTo(
          [active.location.lat - 0.005, active.location.lon - 0.02],
          15,
        );
      }

      setActiveDeviceCode(active.deviceCode);
    }
  }, [dispatcherDuck.active]);

  useEffect(() => {
    if (dispatcherDuck.isTracking) {
      handleMove();
    } else {
      //если отслеживание отключено очищаем список отслежваемых кнс/внс
      dispatcherDuck.trackingKns = [];
      dispatcherDuck.trackingVns = [];
    }
  }, [dispatcherDuck.isTracking]);

  useEffect(() => {
    const list = dispatcherDuck.getList();
    const locations = list.reduce((previousValue: any, currentValue) => {
      previousValue[currentValue.locationId] = {
        location: currentValue.location,
        popups: previousValue[currentValue.locationId]?.popups
          ? [...previousValue[currentValue.locationId].popups, currentValue]
          : [currentValue],
      };
      return previousValue;
    }, {});
    setLocations(locations);
  }, [
    JSON.stringify(dispatcherDuck.knses),
    JSON.stringify(dispatcherDuck.vnses),
  ]);

  return (
    <>
      {Object.keys(locations).map((locationId, index) => {
        const {
          location: { lat, lon },
          popups,
        }: any = locations[locationId];
        return (
          <Marker
            key={`marker-${locationId}-${index}`}
            position={[lat, lon]}
            eventHandlers={{
              click: () => {
                if (popups.length === 1) {
                  dispatcherDuck.active = popups[0];
                }
              },
            }}
            icon={divIcon({
              className: "custom icon",
              html: renderToStaticMarkup(<MarkerKnsVns popups={popups} />),
            })}>
            {popups.length > 1 ? (
              <Popup key={`marker-popup-${locationId}-${index}`}>
                <List
                  key={`marker-list-${locationId}-${index}`}
                  sx={{
                    width: "100%",
                    maxWidth: 360,
                    bgcolor: "background.paper",
                  }}>
                  {popups.map((itemKnsVns: Kns | Vns, idx: number) => {
                    const { name, deviceCode, type, emergencyCode, onRepair } =
                      itemKnsVns;
                    const primary =
                      name && name !== ""
                        ? name
                        : `${
                            type === FacilityTypeEnum.KNS ? "KНС" : "ВНС"
                          } №${deviceCode}`;
                    return (
                      <div
                        key={`cont-map-component-popup-item-${locationId}-${index}-${idx}`}>
                        <ListItem
                          key={`map-component-popup-item-${locationId}-${index}-${idx}`}
                          onClick={() => {
                            dispatcherDuck.active = itemKnsVns;
                          }}>
                          {null}
                          <MarkerIconContainer>
                            {onRepair ? (
                              <RepairIcon />
                            ) : someIncludes(emergencyCode, [
                                DeviceEmergencyCodeEnum.nonEmergency,
                                DeviceEmergencyCodeEnum.phaseControlError,
                              ]) ? (
                              <GreenPointIcon />
                            ) : (
                              <ErrorIcon />
                            )}
                          </MarkerIconContainer>
                          <div>
                            <Typography gutterBottom component="div">
                              {primary}
                            </Typography>
                          </div>
                        </ListItem>
                        <Divider />
                      </div>
                    );
                  })}
                </List>
              </Popup>
            ) : null}
          </Marker>
        );
      })}
    </>
  );
});
